export const createIcsFileText = eventsText => {
  return (
    'BEGIN:VCALENDAR\n' +
    'CALSCALE:GREGORIAN\n' +
    'METHOD:PUBLISH\n' +
    'PRODID:-//pflegenetzwerk//DE\n' +
    'VERSION:2.0\n' +
    eventsText +
    'END:VCALENDAR'
  )
}

export const createIcsFileEventText = ({ start, summary, description, uid }) => {
  return (
    'BEGIN:VEVENT\n' +
    'TZID:Europe/Warsaw\n' +
    `UID:${uid}\n` +
    `DTSTART:${start}\n` +
    `SUMMARY:${summary}\n` +
    `DESCRIPTION:${description}\n` +
    'END:VEVENT\n'
  )
}
